import { createContext } from 'react';

// Create a new context.
export const UserContext = createContext();